/**
 * DOC-4 — Keyston Bros demo seed.
 *
 * Three parse inputs that pre-populate the kairos-demo Auto-Builder / Keyston
 * flow history. Each has a parse job + result so the UI has examples to show.
 *
 * Context: Keyston Bros — flooring distributor, Dallas DCs, LTL heavy.
 * Sales context: Tommy Duncan + Andrew Kahn demo.
 */

const NOW = '2026-04-18T11:00:00Z';

export const SEED_KEYSTON_PARSE_JOBS = [
  { id: 'pj_kb_email_01',  userId: 'user-001', inputCount: 1, correlate: false, status: 'complete', createdAt: NOW, completedAt: NOW },
  { id: 'pj_kb_excel_01',  userId: 'user-001', inputCount: 1, correlate: false, status: 'complete', createdAt: NOW, completedAt: NOW },
  { id: 'pj_kb_photo_01',  userId: 'user-001', inputCount: 1, correlate: false, status: 'complete', createdAt: NOW, completedAt: NOW },
];

export const SEED_KEYSTON_PARSE_RESULTS = [
  {
    id: 'pr_kb_email_01',
    parseJobId: 'pj_kb_email_01',
    inputIndex: 0,
    type: 'email',
    filename: null,
    ok: true,
    documentType: 'TENDER',
    fields: {
      customer: 'Keyston Bros',
      shipper_name: 'Keyston Bros — Dallas DC',
      shipper_address: '2100 Stemmons Fwy, Dallas TX 75212',
      consignee_name: 'Phoenix Flooring Supply',
      consignee_address: '3415 W Van Buren St, Phoenix AZ 85009',
      origin_city: 'Dallas', origin_state: 'TX',
      destination_city: 'Phoenix', destination_state: 'AZ',
      pieces: 480, weight_lbs: 12400, pallets: 8,
      commodity: 'Prefinished oak flooring 3/4 x 5"',
      freight_class: 70,
      mode: 'LTL',
      pickup_date: '2026-04-20',
      reference_number: 'KB-90214',
      bol_number: null, po_number: 'PHX-00912',
    },
    confidencePerField: {
      customer: 98, shipper_name: 95, shipper_address: 94, consignee_name: 93, consignee_address: 88,
      origin_city: 98, origin_state: 98, destination_city: 96, destination_state: 97,
      pieces: 92, weight_lbs: 94, freight_class: 87, commodity: 90, mode: 97,
      pickup_date: 92, reference_number: 98, po_number: 94,
    },
    sourceSnippet: 'From: tommy@keystonbros.com · Subject: LTL tender Dallas → Phoenix — PO PHX-00912 · 480 pieces oak …',
    provider: 'seed',
    createdAt: NOW,
  },
  {
    id: 'pr_kb_excel_01',
    parseJobId: 'pj_kb_excel_01',
    inputIndex: 0,
    type: 'email',
    filename: null,
    ok: true,
    documentType: 'TENDER',
    fields: {
      customer: 'Keyston Bros',
      shipper_name: 'Keyston Bros — Houston DC',
      shipper_address: '8820 Market St, Houston TX 77029',
      consignee_name: 'Cinco Ranch Hardwoods',
      consignee_address: '23535 Cinco Ranch Blvd, Katy TX 77494',
      origin_city: 'Houston', origin_state: 'TX',
      destination_city: 'Katy', destination_state: 'TX',
      pieces: 220, weight_lbs: 6800,
      commodity: 'Luxury vinyl plank, assorted',
      freight_class: 92.5,
      mode: 'LTL',
      pickup_date: '2026-04-21',
      reference_number: 'KB-90220',
    },
    confidencePerField: {
      customer: 96, shipper_name: 92, shipper_address: 81, consignee_name: 88, consignee_address: 78,
      origin_city: 96, origin_state: 98, destination_city: 89, destination_state: 96,
      pieces: 88, weight_lbs: 82, freight_class: 72, commodity: 80, mode: 95,
      pickup_date: 86, reference_number: 94,
    },
    sourceSnippet: 'TABLE:\nSKU\tDescription\tQty\tWeight\tClass\nKB-LVP-501\tLVP oak natural\t120\t3720\t92.5\n…',
    provider: 'seed',
    createdAt: NOW,
  },
  {
    id: 'pr_kb_photo_01',
    parseJobId: 'pj_kb_photo_01',
    inputIndex: 0,
    type: 'image',
    filename: 'kb-warehouse-bol.jpg',
    ok: true,
    documentType: 'BOL',
    fields: {
      customer: 'Keyston Bros',
      shipper_name: 'Keyston Bros — Dallas DC',
      shipper_address: '2100 Stemmons Fwy, Dallas TX 75212',
      consignee_name: 'Austin Flooring Direct',
      consignee_address: 'Austin TX',
      origin_city: 'Dallas', origin_state: 'TX',
      destination_city: 'Austin', destination_state: 'TX',
      pieces: 96, weight_lbs: 2840,
      commodity: 'Engineered hardwood — walnut 5"',
      freight_class: 85,
      mode: 'LTL',
      pickup_date: '2026-04-19',
      reference_number: 'KB-90217',
    },
    confidencePerField: {
      customer: 86, shipper_name: 85, shipper_address: 74, consignee_name: 72, consignee_address: 54, // low
      origin_city: 92, origin_state: 95, destination_city: 85, destination_state: 92,
      pieces: 60, weight_lbs: 58, // low
      freight_class: 78, commodity: 80, mode: 88,
      pickup_date: 70, reference_number: 84,
    },
    sourceSnippet: 'BILL OF LADING (photo) · Keyston Bros DAL · PRO …',
    provider: 'seed',
    createdAt: NOW,
  },
];
